export const CAROUSEL = [
    {
      header: {
        icon: "pi pi-hourglass",
        text: "Hire Smarter, Not Slower"
      },
      content: {
        // heading: "Our AI-powered hiring platform streamlines the entire recruitment process",
        list: [
          "AI-powered candidate scoring at a glance.",
          "Create jobs and events with just a prompt.",
          "Shortlist top talent in minutes, not days."
        ]
      },
      footer: ["Fast Screening", "Smart Decisions", "Quality Hires"]
    },
    {
      header: {
        icon: "pi pi-wave-pulse",
        text: "Post-Interview Insights, Instantly"
      },
      content: {
        // heading: "Accelerate hiring with intelligent automation",
        list: [
          "Analyze interviews automatically with AI.",
          "Get actionable candidate insights and scores.",
          "Make confident hiring decisions faster."
        ]
      },
      footer: ["Instant Analysis", "Data-Driven Decisions", "Reduce Bias"]
    },
    {
      header: {
        icon: "pi pi-shield",
        text: "Automate the Busywork"
      },
      content: {
        // heading: "Streamline recruitment with AI-driven automation",
        list: [
          "From scheduling to scoring, let AI handle it.",
          "Reduce errors, cut manual effort, and save time.",
          "Focus on what matters."
        ]
      },
      footer: ["Boost Productivity", "Cut Repetition", "Maximize Impact"]
    },
  ]